'use client';

import { BaseLayout } from 'structure/Layouts/SFILayouts/BaseLayout/BaseLayout';
import { VaultLayout } from 'structure/pv2/vault/VaultLayout';

export function VaultClient() {
  return (
    <BaseLayout>
      <VaultLayout />
    </BaseLayout>
  );
}
